import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import softwareDetailsActions from '../actions/softwareDetails';

// responds to 'GET_SOFTWARE_SUGGESTIONS' action
function getSoftwareSuggestions(store, action) {
    request.get(`/${config.url_prefix}/api/software/search?searchQuery=${action.payload.searchString}`)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(softwareDetailsActions.alertError(errorKey));
            } else {
                const parsedResponse = JSON.parse(response.text);
                if (parsedResponse instanceof Array) {
                    store.dispatch(softwareDetailsActions.getSoftwareSuggestionsSuccess(parsedResponse));
                } else {
                    const errorKey = 'ipmob.error.process.request';
                    store.dispatch(softwareDetailsActions.alertError(errorKey));
                }
            }
        });
}

export default getSoftwareSuggestions;
